<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div v-if="trip.account" class="form-group col-sm-12">
          <label for="account_id">Account:</label>
          <input class="form-control" disabled name="account_id" type="text" v-model="trip.account.account_name">
      </div>
      <div v-if="trip.route" class="form-group col-sm-12">
          <label for="route_id">Route:</label>
          <input class="form-control" disabled name="route_id" type="text" v-model="trip.route.route_name">
      </div>
      <div class="form-group col-sm-12 required" v-if="trip.route && trip.route.route_direction == 3">
        <label for="route_id">Sub Route:</label>
        <select class="form-control" required name="sub_route_id" v-model.number="trip.sub_route_id">
          <option value="">--- Please Select One ---</option>
          <option v-for="r in sub_routes" :key="r" :value="r.id">{{r.sub_route_name}}</option>
        </select>
      </div>
      <div class="form-group col-sm-12">
          <label for="trip_code">Trip Code:</label>
          <input class="form-control" disabled name="trip_code" type="text" v-model="trip.trip_code">
      </div>
      <div class="form-group col-sm-12 col-md-6 ">
        <label for="vehicle_id">Vehicle:</label>
        <Select2 name="vehicle_id" v-model.number="trip.vehicle_id" :options="vehicleOptions" />
      </div>
      <div class="form-group col-sm-12 col-md-6 ">
        <label for="driver_id">Driver:</label>
        <Select2 name="driver_id" v-model.number="trip.driver_id" :options="driverOptions" />
      </div>
      <div class="form-group col-sm-12 col-md-12 required">
        <label for="trip_date">Trip Date:</label>
        <input class="form-control" name="trip_date" type="date" required v-model="trip_date" @blur="onChangeDate()">
      </div>      
      <div class="form-group col-sm-12 col-md-12 ">
        <label for="road_warrant_id">Road Warrant:</label>
        <Select2 name="road_warrant_id" v-model.number="trip.road_warrant_id" :options="roadWarrantOptions" />
      </div>
      <div class="form-group col-sm-12 col-md-6 required">
        <label for="estimation_trip_start_date">Estimation Start Date:</label>
        <input class="form-control" name="estimation_trip_start_date" type="date" required v-model="estimation_start_date">
      </div>
      <TimeComponent :label="'Estimation Start Time'" :selected_time="estimation_start_time" v-on:selected-time="setStart"/>
      <div class="form-group col-sm-12 col-md-6 required">
        <label for="estimation_trip_start_date">Estimation Finish Date:</label>
        <input class="form-control" name="estimation_trip_start_date" type="date" required v-model="estimation_finish_date">
      </div>
      <TimeComponent :label="'Estimation Finish Time'" :selected_time="estimation_finish_time" v-on:selected-time="setFinish"/>
      <div class="form-group col-sm-6 col-md-6 required">
        <label for="status">Total Penumpang:</label>
        <input class="form-control" name="total_penumpang" type="number" required v-model.number="trip.total_penumpang">
      </div>
      <div class="form-group col-sm-6 col-md-6 required">
        <label for="status">Penumpang Rit 1:</label>
        <input class="form-control" name="penumpang1" type="number" required v-model.number="trip.penumpang1">
      </div>
      <div class="form-group col-sm-6 col-md-6">
        <label for="male">Male Passenger:</label>
        <input class="form-control" name="male" type="number" v-model.number="trip.male">
      </div>
      <div class="form-group col-sm-6 col-md-6">
        <label for="female">Female Passenger:</label>
        <input class="form-control" name="female" type="number" v-model.number="trip.female">
      </div>
      <div class="form-group col-sm-6 col-md-6">
        <label for="status">Total Revenue:</label>
        <input class="form-control" name="total_revenue" type="number" v-model.number="trip.total_revenue">
      </div>
      <div class="form-group col-sm-6 col-md-6">
        <label for="status">Revenue Rit 1:</label>
        <input class="form-control" name="revenue1" type="number" v-model.number="trip.revenue1">
      </div>
      <div class="form-group col-sm-12 col-md-12 required">
        <label for="status">Status:</label>
        <select class="form-control" name="status" v-model.number="trip.status">
          <option value="0" style="color:black;">Draft</option>
          <option value="1" style="color:black;">Started</option>
          <option value="2" style="color:black;">Completed One Trip</option>
          <option value="3" style="color:black;">Completed</option>
          <option value="4" style="color:black;">Cancelled</option>
        </select>
      </div>
      <div class="form-group col-sm-12 col-md-6">
        <label for="start">Trip Start:</label>
        <input class="form-control" name="start" type="text" disabled v-model="trip_start">
      </div>
      <div class="form-group col-sm-12 col-md-6">
        <label for="finish">Trip Finish:</label>
        <input class="form-control" name="finish" type="text" disabled v-model="trip_finish">
      </div>
      <div class="form-group col-sm-12 col-md-6">
        <label for="start">Adjust Trip Start:</label>
        <input class="form-control" name="adjust_trip_start" type="time" v-model="adjust_trip_start">
      </div>
      <div class="form-group col-sm-12 col-md-6">
        <label for="finish">Adjust Trip Finish:</label>
        <input class="form-control" name="adjust_trip_finish" type="time" v-model="adjust_trip_finish">
      </div>
      <div class="form-group col-sm-12 col-md-6">
        <label for="distance">Distance:</label>
        <input class="form-control" name="distance" type="number" v-model.number="trip.distance" step="any">
      </div>
      <div class="form-group col-sm-12 col-md-6">
        <label for="bbm">BBM (Liter):</label>
        <input class="form-control" name="bbm" type="number" v-model.number="trip.bbm" step="any">
      </div>
      <InputImage label="Picture" v-on:selected-image="setImage"/>
      <div v-if="trip.pic_url" class="form-group col-sm-12">
        <img :src="trip.pic_url" height="200"/>
      </div>
      <div class="form-group col-sm-12 col-md-12">
        <label for="playback_file">Upload Playback:</label><br/>
        <input type="file" name="playback_file" @change="onChangeFilePlayback"/><br/>
        <input class="btn btn-secondary mt-1" value="Download Template" @click.prevent="download_template">
      </div>   
      <div class="form-group col-sm-12">
        <input class="btn btn-primary" type="submit" value="Save">
        <router-link class="btn btn-default ml-1" to="/trips">Cancel</router-link>
      </div>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </form>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment'
  import TimeComponent from '../components/TimeComponent.vue'
  import InputImage from '../components/InputImage.vue'
  import Select2 from 'vue3-select2-component';
  import * as XLSX from "xlsx"
  export default {
    computed: {
        ...mapState('trips', ['trip', 'onRequest']),
        ...mapState('sub_routes', ['sub_routes']),
        ...mapState('vehicles', ['vehicles']),
        ...mapState('road_warrants', ['road_warrants']),
        ...mapState('drivers', ['drivers']),
        trip_date:{
          get(){
            if(this.trip && this.trip.trip_date){
              return moment(this.trip.trip_date).format("YYYY-MM-DD")
            }
            return null
          },
          set(val){
            this.trip.trip_date = val
          }
        },
        trip_start(){
          if(this.trip && this.trip.start){
            return moment(this.trip.start).format("lll")
          }
          return ''
        },
        trip_finish(){
          if(this.trip && this.trip.finish){
            return moment(this.trip.finish).format("lll")
          }
          return ''
        },
    },
    data(){
      return {
        estimation_start_date: moment().format("YYYY-MM-DD"),
        estimation_finish_date: moment().format("YYYY-MM-DD"),
        estimation_start_time: '07:00',
        estimation_finish_time: '16:00',
        adjust_trip_start: null,
        adjust_trip_finish: null,
        file_image: null,
        vehicleOptions: [],
        driverOptions: [],
        roadWarrantOptions: [],
        playback_datas: []
      }
    },
    components:{
      TimeComponent,
      InputImage,
      Select2
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        this.trip.trip_date = this.trip_date
        this.trip.estimation_start = this.estimation_start_date + " " + this.estimation_start_time
        this.trip.estimation_finish = this.estimation_finish_date + " " + this.estimation_finish_time
        if(this.adjust_trip_start){
          this.trip.adjust_trip_start = moment(this.estimation_start_date + " " + this.adjust_trip_start).utc().format("YYYY-MM-DD HH:mm")
        }
        if(this.adjust_trip_finish){
          this.trip.adjust_trip_finish = moment(this.estimation_finish_date + " " + this.adjust_trip_finish).utc().format("YYYY-MM-DD HH:mm")
        }
        this.trip.file_image = this.file_image
        this.trip.playback_datas = this.playback_datas
        this.trip.trip_histories = []
        this.adjust(this.trip)
      },
      ...mapActions('trips', ['adjust', 'get']),
      ...mapActions('vehicles', {getVehicles: 'get_vehicle_by_route'}),
      ...mapActions('drivers', {getDrivers: 'get_driver_by_account'}),
      ...mapActions('sub_routes', {getSubRoutes: 'get_sub_route_by_route'}),
      ...mapActions('road_warrants', {getDataByAccount: 'get_road_warrant_by_account'}),
      setStart(val){
        this.estimation_start_time = val
      },
      setFinish(val){
        this.estimation_finish_time = val
      },
      setImage(image){
        this.file_image = image
      },      
      onChangeDate(){        
        this.trip.road_warrant_id = ''
        this.getDataByAccount({account_id : this.trip.account_id, from_date: this.trip.trip_date, to_date: this.trip.trip_date})
      },
      download_template(){
        window.open('/template_playback.xlsx')
      },      
      onChangeFilePlayback(event){
        this.file = event.target.files ? event.target.files[0] : null;
        if (this.file) {
          const reader = new FileReader();

          reader.onload = () => {
            this.arrayBuffer = reader.result;
            var data = new Uint8Array(this.arrayBuffer);
            var arr = new Array();
            for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            var bstr = arr.join("");
            var workbook = XLSX.read(bstr, {
              type: "binary"
            });
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];
            let res = XLSX.utils.sheet_to_json(worksheet, {
              raw: false
            })
            let arrs = []
            res.map(item => {
              if(!item["Time"] || item["Time"] == null || !item["Status"] || item["Status"] == null){
                return
              }
              let a = {trip_id: this.trip.id, time: null, lat: null, lng: null, speed: null, course: null, status: 1}
              a.time = moment.utc(item["Time"].trim()).format("YYYY-MM-DD HH:mm:ss")
              a.lat = parseFloat(item["Latitude"])
              a.lng = parseFloat(item["Longitude"])
              a.speed = parseInt(item["Speed"])
              a.course = parseInt(item["Course"])
              switch(item["Status"].trim()){
                case 'Stop':
                case 'stop':
                  a.status = 2
                  break
                default:
                  a.status = 1
                  break
              }
              arrs.push(a)
            })
            this.playback_datas = arrs
          }

          reader.readAsArrayBuffer(this.file);
        }
      },
    },
    created() {
      this.$emit('onChildInit', 'Adjust Trip')
      this.get(this.$route.params.id)
    },
    watch:{
      trip(nextState, prevState){
        if(nextState !== prevState){
          if(nextState.route_id){
            this.getVehicles({route_id : nextState.route_id})
            this.getSubRoutes({route_id : nextState.route_id})
          }
          if(nextState.account_id){
            this.getDrivers({account_id : nextState.account_id})
            this.getDataByAccount({account_id : nextState.account_id, from_date: nextState.trip_date, to_date: nextState.trip_date})
          }
          if(nextState.estimation_start){
            this.estimation_start_date = moment.utc(nextState.estimation_start).format("YYYY-MM-DD")
            this.estimation_start_time = moment.utc(nextState.estimation_start).format("HH:mm")
          }
          if(nextState.estimation_finish){
            this.estimation_finish_date = moment.utc(nextState.estimation_finish).format("YYYY-MM-DD")
            this.estimation_finish_time = moment.utc(nextState.estimation_finish).format("HH:mm")
          }
          if(nextState.finish){
            this.adjust_trip_finish = moment(nextState.finish).format("HH:mm")
          }
          if(nextState.start){
            this.adjust_trip_start = moment(nextState.start).format("HH:mm")
          }
          return
        }
      },
      vehicles(nextState, prevState){
        if(nextState !== prevState){
          this.vehicleOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.vehicleOptions.push({id:item.id, text:item.vehicle_no +' - '+item.vehicle_code})
            })
      }
          return
        }
      },
      drivers(nextState, prevState){
        if(nextState !== prevState){
          this.driverOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.driverOptions.push({id:item.id, text:item.name})
            })
          }
          return
        }
      },      
      road_warrants(nextState, prevState){
        if(nextState !== prevState){
          this.roadWarrantOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.roadWarrantOptions.push({id:item.id, text:item.road_warrant_code})
            })
          }
          return
        }
      },
    }
  }
</script>
